import { ethers } from "ethers";
import { CONTRACT_ABI } from "./contractABI";


// Proxy contract address //contract address deployed using remix and verified on amoy testnet
//0xfd408D03facb9343880e73f228dea6E3C3efBd49 InviteProtocolV2 contract address

//0x08bC4c575f87F99806B5ef4406115a81bed7B748 new mobius Proxy address

export const CONTRACT_ADDRESS = "0x8Cfaf2291907580C327668E4074cB13adaac5C5e";   // localhost deployment

export const getContractInstance = (provider: ethers.Provider | ethers.Signer) => {
  return new ethers.Contract(CONTRACT_ADDRESS, CONTRACT_ABI, provider);
};

export { CONTRACT_ABI };
